import type { LogEventInput } from '../events';

export const KeepaliveRequestBodyLimitInBytes = 60000;
const JsonArrayBracketsSizeInBytes = 2;
const JsonArrayItemSeparatorSizeInBytes = 1;

type GetKeepaliveRequestBodySize = (events: LogEventInput[]) => number;
export const getKeepaliveRequestBodySize: GetKeepaliveRequestBodySize = (events) =>
  new Blob([JSON.stringify(events)]).size;

type IsKeepaliveRequestBodyWithinLimit = (events: LogEventInput[]) => boolean;
export const isKeepaliveRequestBodyWithinLimit: IsKeepaliveRequestBodyWithinLimit = (events) =>
  getKeepaliveRequestBodySize(events) <= KeepaliveRequestBodyLimitInBytes;

type GetLogEventsWithinKeepaliveRequestBodyLimit = (
  requiredEvent: LogEventInput,
  optionalEvents: LogEventInput[]
) => LogEventInput[];
export const getLogEventsWithinKeepaliveRequestBodyLimit: GetLogEventsWithinKeepaliveRequestBodyLimit = (
  requiredEvent,
  optionalEvents
) => {
  const selectedEvents = [requiredEvent];
  let requestBodySize = getKeepaliveRequestBodySize(selectedEvents);

  for (const optionalEvent of optionalEvents) {
    const optionalEventSize = getKeepaliveRequestBodySize([optionalEvent]) - JsonArrayBracketsSizeInBytes;
    if (requestBodySize + optionalEventSize + JsonArrayItemSeparatorSizeInBytes <= KeepaliveRequestBodyLimitInBytes) {
      selectedEvents.push(optionalEvent);
      requestBodySize += optionalEventSize + JsonArrayItemSeparatorSizeInBytes;
    }
  }

  return selectedEvents;
};
